import Contact from '../../assets/images/Phone2.webp';
import Background from '../../assets/images/ContactBackground.webp';
import Title from '../Common/Title';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { contactUsSchema } from '../../utils/schemas';
import { ContactFormService } from '../../services/profile/profileService';
import { useToast } from '@chakra-ui/toast';
import { useState } from 'react';
import Spin from '../Common/loaders/Spin';
import { Link } from 'react-router-dom';
import { POLITICS, TERMS_AND_CONDITIONS } from '../../routes/app/paths';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FiUser, FiMail, FiPhone, FiFileText } from 'react-icons/fi';

function ContactUs({ onComplete }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(contactUsSchema),
  });
  const toast = useToast();
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = (e) => {
    setIsSubmitting(true);
    ContactFormService(e)
      .then(() => {
        toast({
          title: 'Mensaje enviado',
          description: 'Tu mensaje ha sido enviado con éxito.',
          status: 'success',
          duration: 2000,
          position: 'top-right',
          isClosable: true,
        });
        reset();
        if (onComplete) {
          onComplete();
        }
      })
      .catch((error) => {
        toast({
          title: 'Error',
          description: 'Tu mensaje no ha podido ser enviado.',
          status: 'error',
          duration: 2000,
          position: 'top-right',
          isClosable: true,
        });
        console.error(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <section className="" id='contacto'>
      <div className="relative flex items-end py-0 -mt-2"
        style={{ backgroundImage: `url(${Background})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        {/* phone image */}
        <img src={Contact} alt="Contact" className="h-1/2 object-bottom aspect-auto w-1/2 hidden lg:block" />

        {/* form */}
        <div className="max-w-7xl py-10 lg:h-screen flex items-center justify-center lg:gap-x-10 lg:px-8 grow">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="shadow-xl border-[1px] border-gray-300 bg-gradient-to-b from-transparent via-[#c4bebe8a] to-transparent rounded-none sm:rounded-[50px] p-6 mx-auto max-w-md lg:mx-0 lg:flex-auto backdrop-blur-sm relative"
          >
            <Title className='py-4' color title={t('contactUs.title')} align="center" />
            <div>
              <div className="relative">
                <FiUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  className="block w-full bg-[#ffffffbc] rounded-full border-0 pl-10 pr-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  placeholder={t('contactUs.namePlaceholder')}
                  {...register('name')}
                />
                {errors.name && (
                  <span className="text-bubble-gum text-xs">
                    {errors.name.message}
                  </span>
                )}
              </div>
              <div className="mt-[14px]">
                <div className="relative">
                  <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    className="block w-full bg-[#ffffffbc] rounded-full border-0 pl-10 pr-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={t('contactUs.emailPlaceholder')}
                    {...register('email')}
                  />
                  {errors.email && (
                    <span className="text-bubble-gum text-xs block mt-2">
                      {errors.email.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="mt-[14px]">
                <div className="relative">
                  <FiPhone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    className="block w-full bg-[#ffffffbc] rounded-full border-0 pl-10 pr-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={t('contactUs.phonePlaceholder')}
                    {...register('phone')}
                  />
                  {errors.phone && (
                    <span className="text-bubble-gum text-xs block mt-2">
                      {errors.phone.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="mt-[14px] relative">
                <FiFileText className="absolute left-4 top-4 text-gray-400" />
                <textarea
                  rows={6}
                  placeholder={t('contactUs.messagePlaceholder')}
                  className="block bg-[#ffffffbc] w-full resize-none rounded-xl border-0 pl-10 pt-3 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  defaultValue={''}
                  {...register('message')}
                  maxLength={500}
                />
                {errors.message && (
                  <span className="text-bubble-gum text-xs">
                    {errors.message.message}
                  </span>
                )}
              </div>
            </div>
            <div>
              <div className="relative flex items-start mt-5">
                <div className="flex h-6 items-center">
                  <input
                    type="checkbox"
                    aria-describedby="offers-description"
                    className="h-4 w-4 rounded-md border-gray-500 text-bubble-gum focus:ring-black"
                    {...register('terms')}
                  />
                </div>
                <div className="ml-3 text-xs font-semibold leading-1">
                  <span className="">
                    {t('contactUs.acceptTerms')}
                    <Link
                      to={TERMS_AND_CONDITIONS}
                      className="cursor-pointer hover:text-primary underline"
                    >
                      {t('contactUs.termsAndConditions')}
                    </Link>{' '}
                    {t('contactUs.andConfirmPrivacyPolicy')}
                    <Link
                      to={POLITICS}
                      className="cursor-pointer hover:text-primary underline"
                    >
                      {t('contactUs.privacyPolicy')}
                    </Link>
                  </span>
                </div>
              </div>
              {errors.terms && (
                <span className="text-bubble-gum text-xs">
                  {errors.terms.message}
                </span>
              )}
            </div>
            <div className="flex justify-center mt-16 md:mt-12">
              <button
                type="submit"
                className="w-full sm:w-fit py-2 px-6 inline-flex justify-center gap-3 items-center text-md lg:text-xl font-normal rounded-full text-white bg-primary hover:bg-[#1f928d] hover:shadow-lg disabled:bg-gray-300"
                disabled={isSubmitting}
              >
                {isSubmitting ? t('contactUs.sending') : t('contactUs.send')}
                {isSubmitting && <Spin />}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

ContactUs.propTypes = {
  onComplete: PropTypes.func,
};

export default ContactUs;
